
/* eslint-disable import/no-cycle */
import { BaseMessage } from './Message';
import type { MessageParamsInput } from './MessageParams';
import TextMessage from './text-message/TextMessage';
import FileMessage from './file-message/FileMessage';
import type { FileMessageInput } from './file-message/FileMessage';
import PreviewMessage from './preview-message/PreviewMessage';

type Message = TextMessage | FileMessage | PreviewMessage;

export type {
  Message,
  MessageParamsInput,
  FileMessageInput,
};

export {
  BaseMessage,
  TextMessage,
  FileMessage,
  PreviewMessage,
}
